import React from "react";

const ReplaceOnWidth = ({content, smContent}) => <>
  <span className="d-inline d-sm-none">{content}</span>
  <span className="d-none d-sm-inline">{smContent}</span>
</>

export default ReplaceOnWidth